import moment from 'moment';
import { MaskedRange } from 'imask';

export const VALUE_DATE_FORMAT = 'YYYY-MM-DD';

export const MIN_DATE = moment('1900-01-01').toISOString();

export const MAX_DATE = moment().toISOString();

export const BLOCKS = {
  YYYY: {
    mask: MaskedRange,
    from: 1900,
    to: new Date().getFullYear(),
  },
  MM: {
    mask: MaskedRange,
    from: 1,
    to: 12,
  },
  DD: {
    mask: MaskedRange,
    from: 1,
    to: 31,
  },
};
